import {classNames} from "@/library/utilities/html"
import Button from "@/components/ui-kit/button"
import useToasts from "@/library/toasts/_hook.toast"

export type ToastProps = {
    refKey: string,
    type?: 'normal' | 'success' | 'warning' | 'error'
    title: string
    message: string

    removed: boolean
    category?: string
    canDismiss?: boolean
    autoClose?: boolean
    autoCloseDelay?: number
}

export default function Toast(props: ToastProps) {
    const {type = 'normal', canDismiss = true, refKey, title, message} = props

    const {closeToast} = useToasts()

    return <div className={classNames("toast", `toast--${type}`)}>
        <div className="toast__title">
            {title}
            {canDismiss && <Button
                className="close-button"
                unStyled={true}
                onClick={() => {
                    closeToast(refKey)
                }}
            ><i className="fas fa-xmark"/></Button>}
        </div>
        <div className="toast__message">{message}</div>
    </div>
}
